import { useState, useEffect, useContext, useCallback } from 'react';
import {
  Table,
  Tooltip,
  Tag,
  Button,
  Row,
  Col,
  Space,
  Input,
  Empty,
  Modal,
  Upload,
  Menu,
  Dropdown,
  Spin,
  message,
} from 'antd';
import moment from "moment";
import { API, Storage } from 'aws-amplify';
import { UserContext } from "../../../../GestorContext";
import { v4 as uuidv4 } from 'uuid';
import '../../../../styles/DataBaseExternal.css';
import ResponsiveVisibility from '../../../common/ResponsiveVisibility';

const { Search } = Input;

const DataBaseExternal = ({
  dataBaseExternal,
  setDataBaseExternal,
  setDBExternalName,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [nameData, setNameData] = useState('');
  const [itemsMenu, setItemsMenu] = useState();
  const [idBaseExterna, setIdBaseExterna] = useState();
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const [loadingAddExternalBase, setLoadingAddExternalBase] = useState(false);
  const userContext = useContext(UserContext);

  const deleteBaseExterna = async (input) => {
    try {
      await API.graphql({
        query: `
          mutation MyQuery($input: DeleteCLMInput!) {
            deleteCLM(input: $input) {
              id
            }
          }`,
        variables: {
          input: input,
        },
      });
      setIsModalOpenDelete(false);
    } catch (err) {
      console.error("Error eliminando base externa", err);
    }
  };

  const onClickMenuAcciones = (record) => (e) => {
    switch (e.key) {
      case "1":
        setIsModalOpenDelete(true);
        setIdBaseExterna(record.id);
        break;
      case "2":
        setDataBaseExternal(null);
        setDBExternalName(null);
        break;
      default:
    }
  };

  const menu = (record) => {
    return <Menu onClick={onClickMenuAcciones(record)} items={itemsMenu} />;
  };

  const columns = [
    {
      title: (
        <ResponsiveVisibility maxWidth={1050}>
          <Row>
            <Col span="18" style={{ top: '15px' }}>
              Nombre
            </Col>
            <Col span="4">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.6 4.5V20.5M6.6 4.5L10.2 8.05556M6.6 4.5L3 8.05556M17.4 20.5V4.5M17.4 20.5L21 16.9444M17.4 20.5L13.8 16.9444" stroke="#7084B1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Col>
          </Row>
        </ResponsiveVisibility>
      ),
      dataIndex: 'name',
      ellipsis: {
        showTitle: false,
      },
      render: (name) => (
        <ResponsiveVisibility maxWidth={1050}>
          <Tooltip placement="topLeft" title={name}>
            {name}
          </Tooltip>
        </ResponsiveVisibility>
      ),
    },
    {
      title: (
        <ResponsiveVisibility maxWidth={1050}>
          <Row>
            <Col span="18" style={{ top: '15px' }}>
              Estado
            </Col>
            <Col span="4">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.6 4.5V20.5M6.6 4.5L10.2 8.05556M6.6 4.5L3 8.05556M17.4 20.5V4.5M17.4 20.5L21 16.9444M17.4 20.5L13.8 16.9444" stroke="#7084B1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Col>
          </Row>
        </ResponsiveVisibility>
      ),
      dataIndex: 'estatus',
      render: (_, { status }) => {
        let color;
        let statusDescription;
        switch (status) {
          case 'FAILED':
            color = 'var(--support-error)';
            statusDescription = 'Error';
            break;
          case 'FINISHED':
            color = 'var(--support-correct)';
            statusDescription = 'Listo';
            break;
          case 'STARTED' || 'RUNNING':
            color = 'var(--support-pend)';
            statusDescription = 'En proceso';
            break;
          case 'PENDING':
            color = 'var(--support-correct)';
            statusDescription = 'Cargada';
            break;
          default:
            color = 'var(--support-pend)';
            statusDescription = 'No disponible';
        }
        return (
          <ResponsiveVisibility maxWidth={1050}>
            <Tag className='tagExports' color={color}>
              {statusDescription}
            </Tag>
          </ResponsiveVisibility>
        );
      },
    },
    {
      title: (
        <>
          <Row>
            <Col className='ColHeader2' span="18">
              Fecha de inicio
            </Col>
            <Col span="4" style={{ top: '8px' }}>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.6 4.5V20.5M6.6 4.5L10.2 8.05556M6.6 4.5L3 8.05556M17.4 20.5V4.5M17.4 20.5L21 16.9444M17.4 20.5L13.8 16.9444" stroke="#7084B1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Col>
          </Row>
        </>
      ),
      dataIndex: 'createdAt',
      width: '200px',
      render: text => moment(text).format("YYYY/MM/DD"),
    },
    {
      title: (
        <>
          <Row>
            <Col span="18" style={{ top: '15px' }}>
              Cargado por
            </Col>
            <Col span="4">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.6 4.5V20.5M6.6 4.5L10.2 8.05556M6.6 4.5L3 8.05556M17.4 20.5V4.5M17.4 20.5L21 16.9444M17.4 20.5L13.8 16.9444" stroke="#7084B1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Col>
          </Row>
        </>
      ),
      dataIndex: 'user',
      width: '200px',
      render: (_, { user }) => (
        <p>{user && user.username ? user.username : 'Desconocido'}</p>
      ),
    },
    {
      title: (
        <>
          <Row>
            <Col className='ColHeader2' span="18">
              Numero<br />de Registros
            </Col>
            <Col span="4" style={{ top: '16px' }}>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.6 4.5V20.5M6.6 4.5L10.2 8.05556M6.6 4.5L3 8.05556M17.4 20.5V4.5M17.4 20.5L21 16.9444M17.4 20.5L13.8 16.9444" stroke="#7084B1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Col>
          </Row>
        </>
      ),
      dataIndex: 'count',
      width: '200px',
    },
    {
      title: (
        <ResponsiveVisibility maxWidth={1050}>
          Acciones
        </ResponsiveVisibility>
      ),
      dataIndex: 'actions',
      render: (_, record) => (
        <Dropdown overlay={() => menu(record)}>
          <a className="optionsButton">
            <svg
              width="3"
              height="10"
              viewBox="0 0 3 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="1.5" cy="1" r="1" fill="#181D2E" />
              <circle cx="1.5" cy="5" r="1" fill="#181D2E" />
              <circle cx="1.5" cy="9" r="1" fill="#181D2E" />
            </svg>
          </a>
        </Dropdown>
      ),
    },
  ];

  const createLog = async (values) => {
    await API.graphql({
      query: `mutation CreateMetrics($input: CreateMetricsInput!) {
                createMetrics(input: $input) {
                    id
                }
            }`,
      variables: {
        input: values
      },
    });
  };

  const getBasesExternas = async (userGroup, isAdmin) => {
    try {
      if (isAdmin) {
        const response = await API.graphql({
          query: `
            query MyQuery ($filter: ModelCLMFilterInput) {
              listCLMS(filter: $filter) {
                items {
                  id
                  name
                  count
                  s3Key
                  user {
                    username
                  }
                  status
                  createdAt
                }
              }
            }
          `,
        });

        setData(response.data.listCLMS.items || []);
        return;
      }

      if (!userGroup) {
        setData([]);
        return;
      }

      let allUsers = [];
      let nextToken = null;

      do {
        const response = await API.graphql({
          query: `
            query MyQuery($filter: ModelUserFilterInput, $nextToken: String) {
              listUsers(filter: $filter, nextToken: $nextToken) {
                items {
                  username
                  clms {
                    items {
                      id
                      name
                      count
                      s3Key
                      cLMUserId
                      status
                      createdAt
                    }
                  }
                }
                nextToken
              }
            }
          `,
          variables: {
            filter: { groups: { eq: userGroup } },
            nextToken,
          },
        });

        const users = response?.data?.listUsers?.items || [];
        allUsers = allUsers.concat(users);
        nextToken = response?.data?.listUsers?.nextToken;
      } while (nextToken);

      const allClms = allUsers.flatMap(user =>
        (user?.clms?.items || []).map(clm => ({
          ...clm,
          user: { username: user?.username || 'Desconocido' },
        }))
      );

      setData(allClms);
    } catch (err) {
      console.error("Error obteniendo bases externas", err);
      message.error('Ocurrió un error al obtener las bases externas');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshBasesExternas = useCallback(() => {
    const userGroup = userContext?.attributes?.["custom:group"];
    const groups = userContext?.signInUserSession?.idToken?.payload?.["cognito:groups"] || [];
    const isAdmin = groups.includes('Admin');

    if (!isAdmin && !userGroup) {
      setLoading(false);
      setData([]);
      return;
    }

    setLoading(true);
    getBasesExternas(userGroup, isAdmin);
  }, [userContext]);

  useEffect(() => {
    refreshBasesExternas();
  }, [refreshBasesExternas, isModalOpenDelete, isModalOpen]);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredData(data);
    } else {
      const filtered = data.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [data, searchTerm]);

  const handleOk = () => {
    setLoadingAddExternalBase(true)
    handleUpload()
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsModalOpenDelete(false);
  };

  useEffect(() => {
    setItemsMenu([
      {
        key: "1",
        label: "Eliminar",
      },
      {
        key: "2",
        label: "Deseleccionar",
      }
    ]);
  }, [data])

  const handleUpload = async () => {
    if (!nameData || nameData.trim() === '') {
      setLoadingAddExternalBase(false);
      return message.error('Ingrese un nombre para la base externa');
    }
    if (!file) {
      setLoadingAddExternalBase(false);
      return message.error('Seleccione un archivo');
    }

    const allowedExtensions = ['txt', 'csv'];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      setLoadingAddExternalBase(false);
      setNameData('');
      setFile(null);
      return message.error('El archivo debe ser de tipo TXT o CSV');
    }

    try {
      const fileContent = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => resolve(event.target.result);
        reader.onerror = (error) => reject(error);
        reader.readAsText(file);
      });

      const lines = fileContent.split('\n').map(line => line.trim());
      if (lines[0] !== 'subscriberid') {
        setLoadingAddExternalBase(false);
        setNameData('');
        setFile(null);
        await createLog({
          action: `El usuario "${userContext.username}" intentó cargar una base de datos externa con un encabezado incorrecto.`,
          id: uuidv4(),
          user: userContext.username,
          view: "CLM general",
        });
        return message.error('Es necesario que el archivo contenga el encabezado subscriberid');
      }

      if (lines.length <= 1) {
        setLoadingAddExternalBase(false);
        setNameData('');
        setFile(null);
        await createLog({
          action: `El usuario "${userContext.username}" intentó cargar una base de datos externa sin líneas de datos.`,
          id: uuidv4(),
          user: userContext.username,
          view: "CLM general",
        });
        return message.error('El archivo debe contener al menos una línea teléfonica después del encabezado.');
      }

      const isValid = lines.slice(1).every(line => {
        return line.length === 10 && /^\d+$/.test(line);
      });

      if (!isValid) {
        setLoadingAddExternalBase(false)
        await createLog({
          action: `El usuario "${userContext.username}" intentó cargar una base de datos externa con líneas inválidas.`,
          id: uuidv4(),
          user: userContext.username,
          view: "CLM general",
        });
        return window.alert('El archivo contiene líneas inválidas. Asegúrese de que cada línea contenga exactamente 10 dígitos numéricos y que no existan espacios.');
      }

      const existingClm = await API.graphql({
        query: `
          query MyQuery($filter: ModelCLMFilterInput) {
            listCLMS(filter: $filter) {
              items { id }
            }
          }
        `,
        variables: { filter: { name: { eq: nameData } } },
      });

      if (existingClm?.data?.listCLMS?.items?.length > 0) {
        setLoadingAddExternalBase(false);
        return message.error('El nombre de CLM ya existe, intenta otro');
      }

      await Storage.put(file.name, file).then(response => {
        API.graphql({
          query: `
            mutation MyMutation($input: createCLMCustomInput!) {
              createCLMCustom(input: $input)
            }
          `,
          variables: {
            input: {
              name: nameData,
              s3_key: `public/${file.name}`,
              user_id: userContext.attributes.sub
            },
          },
        })
      });
      setIsModalOpen(false);
      setNameData('');
      setFile(null);
      setLoadingAddExternalBase(false);
      
      message.loading('Se está procesando la BD externa. Esto tomará 30 segundos...', 30);
      
      let pollCount = 0;
      const pollInterval = setInterval(() => {
        refreshBasesExternas();
        pollCount++;
        if (pollCount >= 12) { 
          clearInterval(pollInterval);
        }
      }, 5000);
    } catch (error) {
      message.error(`Error uploading file: ${error}`);
      setLoadingAddExternalBase(false);
      message.warning('Ocurrió un error al procesar el archivo.');
      setNameData('');
      setFile(null);
    }
  };

  const props = {
    onRemove: file => {
      setFile();
    },
    beforeUpload: file => {
      setFile(file);

      return false;
    },
    multiple: false,
    maxCount: 1,
    accept: '.txt,.csv',
  };

  return (
    <div className='DataBaseExternalComponent'>

      <Modal
        clasName="ModalGA"
        title="Atención"
        open={isModalOpenDelete}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => deleteBaseExterna({ id: idBaseExterna })}
          >
            Eliminar
          </Button>,
        ]}
      >
        <p>¿Estás seguro que deseas eliminar Base Externa?</p>
      </Modal>

      <Spin spinning={loadingAddExternalBase}>
        <Modal
          title="Agregar base externa"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="cancel" onClick={() => {
              setIsModalOpen(false);
              setNameData('');
              setFile(null);
            }}>
              Cancelar
            </Button>,
            <Button
              key="ok"
              type="primary"
              onClick={handleOk}
              disabled={!file || !nameData}
              style={{
                backgroundColor: !file || !nameData ? '#d9d9d9' : '#1890ff',
                borderColor: !file || !nameData ? '#d9d9d9' : '#1890ff',
                color: !file || !nameData ? '#666' : '#fff',
              }}
            >
              Aceptar
            </Button>,
          ]}
        >
          <div className="Text1">
            Nombre de base externa
            <Input
              placeholder="Nombre de base externa"
              value={nameData || ''}
              onChange={(e) => setNameData(e.target.value)}
            />
            <Upload
              {...props}
              fileList={file ? [file] : []}
            >
              <Tooltip
                title={
                  <div style={{ textAlign: 'left' }}>
                    <p>Formato requerido:</p>
                    <ul style={{ margin: 0, paddingInlineStart: 20 }}>
                      <li>Archivos TXT o CSV</li>
                      <li>Encabezado: <strong>subscriberid</strong></li>
                      <li>Líneas con <strong>10 dígitos numéricos</strong></li>
                      <li>Las líneas no deben contener espacios</li>
                    </ul>
                  </div>
                }
                placement="right"
                overlayStyle={{ width: 300 }}
              >
                <Button>Seleccionar archivo</Button>
              </Tooltip>
            </Upload>
          </div>
        </Modal>
      </Spin>

      <Row className='MenuExports' align="middle">
        <Col span={13} className='SubtituloRegularGA'></Col>
        <Col span={7}>
          <Space direction="vertical">
            <Search
              className='SubtituloRegularGA'
              placeholder="Buscar por nombre"
              allowClear
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onSearch={(value) => setSearchTerm(value)}
            />
          </Space>
        </Col>
        <Col span={4}>
          <Button
            className="SubtituloRegularGA Button1"
            type="primary"
            onClick={() => setIsModalOpen(true)}
          >
            Nueva
          </Button>
        </Col>
      </Row>

      <Table
        className='tableDataBaseExternal'
        size="small"
        rowSelection={{
          type: 'radio',
          selectedRowKeys: dataBaseExternal ? [dataBaseExternal] : null,
          onChange: (selectedRowKeys, selectedRows) => {
            setDBExternalName(selectedRows[0]?.name || '');
            const auxSelectedRowKeys = selectedRowKeys[0];
            setDataBaseExternal(auxSelectedRowKeys);
          },
          getCheckboxProps: (record) => ({
            disabled: record.name === 'Disabled User',
            name: record.name,
          }),
        }}
        loading={loading}
        columns={columns}
        dataSource={filteredData}
        rowKey='id'
        scroll={{
          y: 220,
        }}
      />
      {!data.length && <Empty description='Sin datos' />}
    </div>
  );
};

export default DataBaseExternal;

